document.addEventListener('DOMContentLoaded', function() {
  
  // Function to attach click handler to the checkout container
  function attachCheckoutClickHandler() {
    // Try to find checkout button - works with OCU AND without OCU
    const checkoutButton = document.querySelector(
      'input[data-ocu-checkout="true"], ' +          // OCU button
      'input[name="checkout"], ' +                   // Regular Shopify input
      'button[name="checkout"], ' +                  // Regular Shopify button
      'input[type="submit"][value*="paiement"], ' +  // French text fallback
      'input[type="submit"][value*="checkout"]'      // English fallback
    );
    
    if (checkoutButton && !checkoutButton.hasAttribute('data-click-handler-attached')) {
      const parentDiv = checkoutButton.closest('.small-row');
      
      if (parentDiv) {
        // Mark as processed to avoid duplicate handlers
        checkoutButton.setAttribute('data-click-handler-attached', 'true');
        
        // Make entire div clickable
        parentDiv.addEventListener('click', function(e) {
          // Don't trigger if clicking the actual button (prevents double-submit)
          if (e.target === checkoutButton || checkoutButton.contains(e.target)) {
            return;
          }
          
          // Trigger the checkout button click
          checkoutButton.click();
          
          // Optional: Visual feedback
          checkoutButton.style.transform = 'scale(0.98)';
          setTimeout(() => { checkoutButton.style.transform = ''; }, 150);
        });
        
        // Show pointer cursor on hover
        parentDiv.style.cursor = 'pointer';
        
        console.log('✅ Checkout container click handler attached');
        console.log('   Button type:', checkoutButton.getAttribute('data-ocu-checkout') ? 'OCU' : 'Regular Shopify');
      }
    }
  }
  
  // Run immediately (in case button is already there)
  attachCheckoutClickHandler();
  
  // Also run after short delays (in case button is injected asynchronously)
  setTimeout(attachCheckoutClickHandler, 500);
  setTimeout(attachCheckoutClickHandler, 1000);
  setTimeout(attachCheckoutClickHandler, 2000);
  
  // Watch for DOM changes (in case button is injected later)
  const observer = new MutationObserver(function(mutations) {
    attachCheckoutClickHandler();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('🔍 Watching for checkout button...');
});